import { render, staticRenderFns } from "./calendario.vue?vue&type=template&id=51393198&scoped=true"
import script from "./calendario.vue?vue&type=script&lang=js"
export * from "./calendario.vue?vue&type=script&lang=js"
import style0 from "./calendario.vue?vue&type=style&index=0&id=51393198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51393198",
  null
  
)

export default component.exports